'use strict';

angular.module('myConsultApp')
    .factory('CommunicationService', function ($resource, ENV, Session) {

        var communicationService = {};

        communicationService.getCommunication = function (id) {
            var communication = $resource(ENV.apiEndpoint + '/1.0/preferences/communication/:id/',{ id: id },{get:{headers: { 'Authorization': 'Bearer '+Session.accessToken }}});

            return communication.get().$promise.then(function(response) {
               return response.communication;
            });
        };


        communicationService.saveCommunication = function (id, communications) {
            var communication = $resource(ENV.apiEndpoint + '/1.0/preferences/communication/:id/',{ id: id },{save:{method: 'PUT', headers: { 'Authorization': 'Bearer '+Session.accessToken }}});

            var data = {
                'communication': communications,
            }

            return communication.save(data).$promise.then(function(response) {
               return response.communication;
            });
        };

        return communicationService;
  });
